module.exports = __webpack_public_path__ + "static/media/frank_london.crop2.6773b0c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/frank_london.crop2.jpg
// module id = 447
// module chunks = 0